<ng-container *ngIf="!isLoading;else loading">
<div class="pageContainer tabcontent storyMain">
<div class="storySectionScroll">
<div class="tabcontainer marb20 wid100">
  <ng-container *ngIf="(id != null) && (videoCms != null) && !locked && videoButtons.length > 0">
  <div class="storyBtns wid100 right">
    <div class="storybtnContent" [style.display]="topToggleOpen ? 'block' : 'none'">
      <ng-container *ngIf="!locked">
        <ng-container *ngFor="let buttonData of videoButtons; let i = index">
        <button type="button" name="videoButtons{{i}}" id="videoButtons{{i}}" (click)="videoButtonsMethod(buttonData.methodName)" class="blue discartS">
          {{buttonData ? buttonData.displayName : '-'}}
        </button>
      </ng-container>
    </ng-container>
        <ng-container *ngIf="false">       
            <div class="secondaryCta fr" #secondaryCTAs>
              <span class="threedots" (click)="revertListFlag = !revertListFlag">
                <span></span>
                <span></span>
                <span></span>
              </span>
              <div class="revertStoryBlock" *ngIf="revertListFlag">
                <ul>
                    <ng-container *ngFor="let buttonData of videoButtons; let i = index">
                        <li>
                          <button (click)="videoButtonsMethod(buttonData.methodName)">{{buttonData ? buttonData.displayName : '-'}}</button>
                        </li>
                    </ng-container>
                </ul>
              </div>
            </div>
        </ng-container>
    </div>
    <span [class]="topToggleOpen ? 'btnOpen spImg_story' : 'btnOpen spImg_story hideClass'" (click)="topToggleOpen = !topToggleOpen;"></span>
  </div>
</ng-container>
<ng-container>
  <!-- <app-deadlink-story [storyDataInput]="storyData" [headline]="headline" [changeFlag]="changeFlag" [summary]="summary" [focusOnLeadMedia]="focusOnLeadMedia" [storyEditMode]="storyEditMode"></app-deadlink-story> -->
  <div class="formStory fl100" >
    <ul class="storyuL">
      <li #headlineEl >
        <label id="storyButton" >
          Video Title
          <i class="mandate">*</i>
          <span> {{titleSize}} char
            </span>
        </label>
        <div class="dataField bdrfill">
          <div id="editor">
            <ckeditor [editor]="ckEditor2"  id="titleBox"
            [(ngModel)]="ckTitle"
            (ready)="ckchanges($event, 'ready', 'title')"
            (change)="ckchanges($event, 'change', 'title')"
            [config]="cksummaryconfig"
            ></ckeditor>
          </div>
          <!-- <span class="fieldValidation">
          Please remove ((") {{'{}'}} [])</span> -->
        </div>
        <!--div class="storyaction" >
          <span class="deleteHeadline" id="headline2" >
            <i class="icon-delete"></i>
          </span>
        </div-->
      </li>
      <!-- Summary  -->
       <li #summaryEl >
        <label >Description
          <!--span>80  char</span-->
        </label>
        <div class='dataField bdrfill'>
          <div id="editor">
            <ckeditor [editor]="ckEditor1"  id="descriptionBox"
            [(ngModel)]="ckDescription"
            (ready)="ckchanges($event, 'ready', 'desc')"
            (change)="ckchanges($event, 'change', 'desc')"
            [config]="ckdesciptionconfig"
            ></ckeditor>
          </div>
          <!-- <span class="fieldValidation">
            Please remove (")</span> -->
            
        </div>
        <!--div class="storyaction" >
          <span id="summary1" class="deleteHeadline" >
            <i class="icon-delete"></i>
          </span>
        </div-->
      </li>

      <li #headlineEl >
        <label id="storyButton" >
          YT Video Title
          <i class="mandate">*</i>
          <span> {{titleSize}} char
            </span>
        </label>
        <div class="dataField bdrfill">
          <div id="editor">
            <ckeditor [editor]="ckEditor2"  id="titleBox"
            [(ngModel)]="ckYTTitle"
            (ready)="ckchanges($event, 'ready', 'yttitle')"
            (change)="ckchanges($event, 'change', 'yttitle')"
            [config]="cksummaryconfig"
            ></ckeditor>
          </div>
          <!-- <span class="fieldValidation">
          Please remove ((") {{'{}'}} [])</span> -->
        </div>
        <!--div class="storyaction" >
          <span class="deleteHeadline" id="headline2" >
            <i class="icon-delete"></i>
          </span>
        </div-->
      </li>
      <!-- Summary  -->
       <li #summaryEl >
        <label >YT Description
          <!--span>80  char</span-->
        </label>
        <div class='dataField bdrfill'>
          <div id="editor">
            <ckeditor [editor]="ckEditor1"  id="descriptionBox"
            [(ngModel)]="ckYTDescription"
            (ready)="ckchanges($event, 'ready', 'descYT')"
            (change)="ckchanges($event, 'change', 'descYT')"
            [config]="ckdesciptionconfig"
            ></ckeditor>
          </div>
          <!-- <span class="fieldValidation">
            Please remove (")</span> -->
            
        </div>
        <!--div class="storyaction" >
          <span id="summary1" class="deleteHeadline" >
            <i class="icon-delete"></i>
          </span>
        </div-->
      </li>
  <li id="leadMedia">
    <!--ng-container *ngIf="createMode || (videoCms && (videoCms.s3ThumbnailUploadStatus == 'FAILED' || videoCms.s3ThumbnailUploadStatus == 'NOTEXIST'))"-->
    <ng-container *ngIf="(videoCms == null && imageSrc == null) || (videoCms != null && videoCms.thumbnailS3Url == null && imageSrc == null)">
      <!--label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Add thumbnail</label-->
      <label>Add thumbnail
        <img *ngIf="addThumbnailError" class="mandate exclamation-mark" title="{{addThumbnailError}}" src="../../../assets/images/exclamationmark.jpeg"/>

      </label>
      <div class="dataField" (focus)="focusOnLeadMedia = true" (focusout)="focusOnLeadMedia = false"
        (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = false"
        tabindex="3">
        <ul [ngClass]="{'z-high': true}" class="leadMediaIcon">
          <li class="spImg_story" >
            <span class="i_video" [ngClass]="{'active' : false}" (click)="addThumbnail()" >
              <!--input [disabled]="locked" hidden #thumbnailImage type="file" accept="image/*" id="thumbnailFile" name="thumbnailFile" (change)="onFileChange($event)" /-->
              <i class="icon-image"></i>
              <ng-container *ngIf="selectedThumbnailFile">{{selectedThumbnailFile.name}}</ng-container>
            </span>
          </li>
        </ul>
      </div>
    </ng-container>

    <input [disabled]="locked" hidden #thumbnailImage type="file" accept="image/*" id="thumbnailFile" name="thumbnailFile" (change)="onFileChange($event)" />

    <!--ng-container *ngIf="videoCms && videoCms.thumbnailS3Url && videoCms.s3ThumbnailUploadStatus == 'UPLOADED'"-->
    <ng-container *ngIf="(videoCms != null && videoCms.thumbnailS3Url != null) || imageSrc != null">
      <div>
        <label>Thumbnail
          <img *ngIf="addThumbnailError" class="mandate exclamation-mark" title="{{addThumbnailError}}" src="../../../assets/images/exclamationmark.jpeg"/>
        </label>
        <div class="dataField bdrfill">
          <div class="leadimage fl wid100">
            <div class="imageblock">
              <div class="imagepreloader" *ngIf="!true">
                <div class="a" style="--n: 5;">
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
              <ng-container>
                <img [style.visibility]="true ? 'visible' : 'hidden'"
                [src]="imageSrc || videoCms.thumbnailS3Url"
                (load)="imgLoaded($event)" alt="">
              </ng-container>
              <!--ng-container *ngIf="selectedThumbnailFile != null">
                <img id="previewImage" [src]="imageSrc" alt="selected image" />
              </ng-container-->
            </div>
          </div>
        </div>
        <div class="storyaction">
          <ng-container>
            <!--span id="icon-move" class="handle sortpara" *ngIf="!hideDragger"><i class="icon-move"></i></span>
            <span id="buttonEditForImage" class="editBtn" (click)="onelementFocus()"><i class="icon-pickup"></i></span>
            <span id="" class="cropimage" (click)="startCropping()"><i class="icon-crop"></i></span>
            <span class="deleteHeadline" (click)="deleteElement()"><i class="icon-delete"></i></span-->
            <span id="buttonEditForImage" [ngClass]="{'disabled': locked}" class="editBtn" (click)="addThumbnail()"><i class="icon-pickup"></i></span>
          </ng-container>
        </div>

      </div>
    </ng-container>


    <ng-container *ngIf="(videoIframeHtml == null && videoSrc == null && (videoCms != null && videoCms.longVideoS3Url == null)) || (videoCms == null && videoSrc == null) || (videoCms != null && videoCms.longVideoS3Url == null && videoSrc == null)">
      <!--label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Add Video</label-->
      <label>Add Video
        <img *ngIf="videoUploadError" class="mandate exclamation-mark" title="{{videoUploadError}}" src="../../../assets/images/exclamationmark.jpeg"/>
      </label>
      <div class="dataField" (focus)="focusOnLeadMedia = true" (focusout)="focusOnLeadMedia = false"
        (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = false"
        tabindex="3">
        <ul [ngClass]="{'z-high': true}" class="leadMediaIcon">
          <!--div [class]="'imageAction' +  (addVideoPopup ? ' block' : '') ">
           <div class="blockContain" *ngIf="addVideoPopup">
            <div class="uploadimage">
              <i class="icon-upload"></i>
              <div class="upload-btn-wrapper">
                <span class="btn">Upload a new video</span>
                <input type="file" accept="video/*" id="longFile" name="longFile" (change)="onVideoFileChange($event,'longVideo')" />
              </div>
              <div class="headerLight">
                <div class="close fl spImg" (click)="disableshowGallery()"></div>
              </div>
            </div>
            </div></div-->
          <li class="spImg_story" >
            <span class="i_video" [ngClass]="{'active' : false}" (click)="addVideo()" >
              <!--input [disabled]="locked" hidden #longVideo type="file" accept="video/*" id="longFile" name="longFile" (change)="onVideoFileChange($event,'longVideo')" /-->
              <i class="icon-video"></i>
              <ng-container *ngIf="selectedLongVideoFile">{{selectedLongVideoFile.name}}</ng-container>
            </span>
          </li>
        </ul>
      </div>
    </ng-container>

    <input [disabled]="locked" hidden #longVideo type="file" accept="video/*" id="longFile" name="longFile" (change)="onVideoFileChange($event,'longVideo')" />
    <!--ng-container >
      <label [style.visibility]="focusOnLeadMedia ? 'visible' : 'hidden'">Add Short Video</label>
      <div class="dataField" (focus)="focusOnLeadMedia = true" (focusout)="focusOnLeadMedia = false"
        (mouseenter)="focusOnLeadMedia = true" (mouseleave)="focusOnLeadMedia = false"
        tabindex="3">
        <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
          <div [class]="'imageAction' +  (addVideoPopup ? ' block' : '') ">
            <div class="blockContain" *ngIf="addVideoPopup">
             <div class="uploadimage">
               <i class="icon-upload"></i>
               <div class="upload-btn-wrapper">
                 <span class="btn">Upload a new short video</span>
                 <input type="file" accept="video/*" id="shortFile" name="shortFile" (change)="onVideoFileChange($event,'shortVideo')" />
               </div>
               <div class="headerLight">
                 <div class="close fl spImg" (click)="disableshowGallery()"></div>
               </div>
             </div>
             </div></div>
          <li class="spImg_story" >
            <span class="i_video" [ngClass]="{'active' : false}" (click)="addSortVideo()" >
              <input hidden #shortVideo type="file" accept="video/*" id="shortFile" name="shortFile" (change)="onVideoFileChange($event,'shortVideo')" />
              <i class="icon-video"></i>
            </span>
          </li>
        </ul>
      </div>
    </ng-container-->

    <ng-container  *ngIf="videoIframeHtml != null || (videoCms != null &&  videoCms.longVideoS3Url != null) || videoSrc != null">
      <!-- <label></label> -->
      <div #videoEl tabindex="0">
        <label>Video
          <img *ngIf="videoUploadError" class="mandate exclamation-mark" title="{{videoUploadError}}" src="../../../assets/images/exclamationmark.jpeg"/>
        </label>
        <div class="dataField bdrfill">
          <ng-container *ngIf="videoIframeHtml != null">
            <div class="respVideo" [innerHtml]="videoIframeHtml">
            </div>
          </ng-container>
          <ng-container *ngIf="videoIframeHtml == null && (videoCms?.longVideoS3Url != null || videoSrc != null)" >
            <video width="100%" height="100%" [src]="videoSrc || videoCms.longVideoS3Url" type="video/*" controls>
              Your browser does not support the video tag.
            </video>
          </ng-container>
          <!--ng-container *ngIf="videoIframeHtml == null && (videoCms?.longVideoS3Url != null)" >
            <video width="100%" height="100%" [src]="videoCms.longVideoS3Url" type="video/*" controls>
              Your browser does not support the video tag.
            </video>
          </ng-container>
          <ng-container *ngIf="videoIframeHtml == null && (videoSrc != null && selectedLongVideoFile != null)" >
           {{selectedLongVideoFile.name}}
          </ng-container-->
        </div>
        <div class="storyaction">
          <!--ng-container *ngIf="createMode"-->
          <ng-container *ngIf="videoCms.ytPrimaryUploadStatus === 'NOTEXIST' || this.videoCms.ytPrimaryUploadStatus === 'FAILED'">
            <span id="buttonEditForImage" [ngClass]="{'disabled': locked}" class="editBtn" (click)="addVideo()"><i class="icon-pickup"></i></span>
          </ng-container>
        </div>
      </div>
    </ng-container>



  </li>
  </ul>
  
  </div>
</ng-container>
</div>
</div>

  <div class="thirdContainer marb20">
   
    <div class="tabcontent" id="meta">
      <ng-container>
        <div class="preview padb20 fl100">Actions
          <span class="right fr">

            <!--a *ngIf="videoCms != null && (videoCms?.ytPrimaryUploadStatus == 'FAILED' || videoCms?.primaryYoutubeVideo == null)" #preivewMobile tabindex="0" (click)="retryVideoUpload()">
              <span class="molineLink">
                RETRY UPLOAD</span>
            </a-->
            <a *ngIf="editMode && locked && videoCms != null && videoCms?.cmsVideoStatus == 'INPROGRESS'" #preivewMobile tabindex="0" (click)="getVideo()">
              <span class="molineLink">
                RELOAD</span>
            </a>
            <a *ngIf="editMode && locked && videoCms != null && videoCms?.cmsVideoStatus != 'INPROGRESS'" #preivewMobile tabindex="0" (click)="unlockStory()">
              <span class="molineLink">
                UNLOCK</span>
            </a>
            <!--a *ngIf="editMode" #preivewMobile tabindex="0" (click)="edit()">
              <span class="molineLink" [ngClass]="{'disabled': locked}">
                UPDATE</span>
            </a>
            <a *ngIf="createMode" #preivewDesktop tabindex="0" (click)="done()">
              <span class="desktopLink" [ngClass]="{'disabled': locked}">
                DONE</span>
            </a-->
          </span>
        </div>
        </ng-container>
    <div class="usermeta blocks marb20">
      <div class="head">Metadata</div>
      <div class="form">

        <ul _ngcontent-c7="">
          <!--li _ngcontent-c7="" class="">
            <label _ngcontent-c7="">Keywords</label>
            <div _ngcontent-c7="" class="dataField">
              <input _ngcontent-c7="" class="textBox ng-untouched ng-pristine ng-valid" placeholder="Add Keywords here." type="text" >
           </div>
          </li-->
          <li>
            <label>Keywords</label>
            <div class="dataField">
              <tags-creator [data]="videoMetadata.keywords" [editable]="locked" [displayText]="'Add keywords here..'"
                (changefn)="videoMetadata.keywords = $event"
                [storyTags]="true" [marketSuggest]="false" [enableDrag]="enableKeywordsDrag"
                (keypress)="specialCharBlock($event)"
                ></tags-creator>
            </div>
          </li>
          <!--li _ngcontent-c7="" class="">
            <label _ngcontent-c7="">
              Topics
            </label>
            <div _ngcontent-c7="" class="dataField">
              <input _ngcontent-c7="" class="textBox ng-untouched ng-pristine ng-valid" placeholder="Add Topics here." type="text" >
            
            </div>
          </li-->

          <!--li>
            <label>Topics</label>
            <div class="dataField">
              <tags-creator [autoSuggest]="true" [autocompletelist]="[]" [data]="videoMetadata.topics"
                [editable]="locked" [idInput]="'inputAddTopicText'" [displayText]="'Enter text to search Topics..'"
                (changefn)="getNewTopicToAdd($event)" [isTopicFlag]="true"></tags-creator>
              </div>
          </li-->
         
          <!--li _ngcontent-c7="" class="">
            <label _ngcontent-c7="">
              Genre
            </label>
            <div _ngcontent-c7="" class="dataField">
              <input _ngcontent-c7="" class="textBox ng-untouched ng-pristine ng-valid" placeholder="Add Genre here." type="text" >
            
            </div>
          </li-->
          <!--li>
            <label>Genre</label>
            <div class="dataField" id="genreField" tabindex="0" >
              <input [disabled]="locked" id="genreDropdownTextbox" type="text" class="textBox" #genreInput [readonly]="false" placeholder="Add Genre here."
                [(ngModel)]="genreQuery" (keyup)="filterAutoCompleteUp($event ,'genre')"
                (keydown)="filterAutoCompleteDown($event ,'genre')" (focus)="focusInSuggest('genre')" (focusout)="false" (blur)="closeDropdown($event)">
              <ng-container>
                <div #genreList tabindex="0" class="autosuggestion block"
                  *ngIf="filteredGenreSuggestion && filteredGenreSuggestion.length > 0 && inside == 'genre'">
                  <ul *ngFor="let item of filteredGenreSuggestion;let i = index">
                    <li tabindex="0" id="genreDropdown{{i}}" (click)="selectAutoComplete('genre', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item.key}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="inside == 'genre' && filteredGenreSuggestion && (1 > filteredGenreSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li-->
          <!--li>
            <label>Sub Genre</label>
            <div class="dataField" id="subGenreField" tabindex="0" >
              <input [disabled]="locked" id="subGenreDropdownTextbox" type="text" class="textBox" #subGenreInput [readonly]="false" placeholder="Add Sub Genre here."
                [(ngModel)]="subGenreQuery" (keyup)="filterAutoCompleteUp($event ,'subGenre')"
                (keydown)="filterAutoCompleteDown($event ,'subGenre')" (focus)="focusInSuggest('subGenre')" (focusout)="false"  (blur)="closeDropdown($event)">
              <ng-container>
                <div #subGenreList tabindex="0" class="autosuggestion block"
                  *ngIf="filteredSubGenreSuggestion && filteredSubGenreSuggestion.length > 0 && inside == 'subGenre'">
                  <ul *ngFor="let item of filteredSubGenreSuggestion;let i = index">
                    <li tabindex="0" id="subGenreDropdown{{i}}" (click)="selectAutoComplete('subGenre', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item.key}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="inside == 'subGenre' && filteredSubGenreSuggestion && (1 > filteredSubGenreSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li-->
          <!--li _ngcontent-c7="" class="">
            <label _ngcontent-c7="">
              Category
            </label>
            <div _ngcontent-c7="" class="dataField">
              <input _ngcontent-c7="" class="textBox ng-untouched ng-pristine ng-valid" placeholder="Add Category here." type="text" >
            
            </div>
          </li-->
          <li>
            <label>Category</label>
            <div class="dataField"  id="categoryField" tabindex="0" >
              <input [disabled]="locked" id="categoryDropdownTextbox" type="text" class="textBox" #categoryInput [readonly]="false" placeholder="Add Category here."
                [(ngModel)]="categoryQuery" (keyup)="filterAutoCompleteUp($event ,'category')"
                (keydown)="filterAutoCompleteDown($event ,'category')" (focus)="focusInSuggest('category')" (focusout)="false" (blur)="closeDropdown($event)">
              <ng-container>
                <div #categoryList tabindex="0" class="autosuggestion block"
                  *ngIf="filteredCategorySuggestion && filteredCategorySuggestion.length > 0 && inside == 'category'">
                  <ul *ngFor="let item of filteredCategorySuggestion;let i = index">
                    <li tabindex="0" id="categoryDropdown{{i}}" (click)="selectAutoComplete('category', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item.key}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="inside == 'category' && filteredCategorySuggestion && (1 > filteredCategorySuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
          <!--li _ngcontent-c7="" class="">
            <label _ngcontent-c7="">
              Language
            </label>
            <div _ngcontent-c7="" class="dataField">
              <input _ngcontent-c7="" class="textBox ng-untouched ng-pristine ng-valid" placeholder="Add Language here." type="text" >
            
            </div>
          </li-->
          <!--li>
            <label>Language</label>
            <div class="dataField" id="categoryField" tabindex="0" >
              <input [disabled]="locked" id="languageDropdownTextbox" type="text" class="textBox" #languageInput [readonly]="false" placeholder="Add Language here."
                [(ngModel)]="languageQuery" (keyup)="filterAutoCompleteUp($event ,'language')"
                (keydown)="filterAutoCompleteDown($event ,'language')" (focus)="focusInSuggest('language')" (focusout)="false" (blur)="closeDropdown($event)">
              <ng-container>
                <div #languageList tabindex="0" class="autosuggestion block"
                  *ngIf="filteredLanguageSuggestion && filteredLanguageSuggestion.length > 0 && inside == 'language'">
                  <ul *ngFor="let item of filteredLanguageSuggestion;let i = index">
                    <li tabindex="0" id="languageDropdown{{i}}" (click)="selectAutoComplete('language', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item.key}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="inside == 'language' && filteredLanguageSuggestion && (1 > filteredLanguageSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li-->
          <!--li _ngcontent-c7="" class="">
            <label _ngcontent-c7="">
              Primary YT Channel
            </label>
            <div _ngcontent-c7="" class="dataField">
              <input _ngcontent-c7="" class="textBox ng-untouched ng-pristine ng-valid" placeholder="Add Primary YT Channel here." type="text" >
            
            </div>
          </li-->
          <li>
            <label>Primary YT Channel</label>
            <div class="dataField" id="pChannelField" tabindex="0" >
              <input [disabled]="locked || (videoCms && videoCms.primaryYoutubeVideo != null)" id="pChannelDropdownTextbox" [disabled]="editMode" type="text" class="textBox" #pChannelInput [readonly]="false" placeholder="Add Primary YT Channel here."
                [(ngModel)]="pChannelQuery" (keyup)="filterAutoCompleteUp($event ,'pChannel')"
                (keydown)="filterAutoCompleteDown($event ,'pChannel')" (focus)="focusInSuggest('pChannel')" (focusout)="false" (blur)="closeDropdown($event)">
              <ng-container>
                <div #pChannelList tabindex="0" class="autosuggestion block"
                  *ngIf="filteredpChannelSuggestion && filteredpChannelSuggestion.length > 0 && inside == 'pChannel'">
                  <ul *ngFor="let item of filteredpChannelSuggestion;let i = index">
                    <li tabindex="0" id="pChannelDropdown{{i}}" (click)="selectAutoComplete('pChannel', item)" [class.active]="i === currentSelection">
                      <span class="name">{{item.key}}</span>
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="inside == 'pChannel' && filteredpChannelSuggestion && (1 > filteredpChannelSuggestion.length)">
                  <div class="autosuggestion block">
                    <ul>
                      <li>
                        <span class="name">No Results</span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </li>
          <!--li _ngcontent-c7="" class="">
            <label _ngcontent-c7="">
              Secondary YT Channels
            </label>
            <div _ngcontent-c7="" class="dataField">
              <input _ngcontent-c7="" class="textBox ng-untouched ng-pristine ng-valid" placeholder="Add Secondary YT Channels here." type="text" >
            
            </div>
          </li-->
          <!--li>
            <label>Secondary YT Channels</label>
            <div class="dataField">
              <tags-creator #firstMeta [idInput]="'inputAddSChannelText'" [autoSuggest]="true" [autocompletelist]="secondaryChannels" 
                [editable]="false" [displayText]="'Add Secondary YT Channels here.'" (changefn)="getSChannels($event)"
                [isDataKeyValuePair]="false"></tags-creator>
            </div>
          </li-->
          <!--li>
            <label>Secondary YT Channels</label>
            <angular2-multiselect [data]="secondaryChannels" [(ngModel)]="selectedSecondaryChannels" [settings]="dropdownSettings"
              (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
              (onDeSelectAll)="onDeSelectAll($event)">
            </angular2-multiselect>
        </li-->
        <!-- <li>
          <label>Secondary YT Channels</label>
          <div class="dataField" id="sChannelField" tabindex="0" >
            <input [disabled]="locked" id="sChannelDropdownTextbox" [disabled]="editMode" type="text" class="textBox" #pChannelInput [readonly]="false" placeholder="Add Secondary YT Channels here."
              [(ngModel)]="sChannelQuery" (keyup)="filterAutoCompleteUp($event ,'sChannel')"
              (keydown)="filterAutoCompleteDown($event ,'sChannel')" (focus)="focusInSuggest('sChannel')" (focusout)="false" (blur)="closeDropdown($event)">
            <ng-container>
              <div #pChannelList tabindex="0" class="autosuggestion block"
                *ngIf="filteredsChannelSuggestion && filteredsChannelSuggestion.length > 0 && inside == 'sChannel'">
                <ul *ngFor="let item of filteredsChannelSuggestion;let i = index">
                  <li tabindex="0" id="sChannelDropdown{{i}}" (click)="selectAutoComplete('sChannel', item)" [class.active]="i === currentSelection">
                    <span class="name">{{item.key}}</span>
                  </li>
                </ul>
              </div>
              <ng-container *ngIf="inside == 'sChannel' && filteredsChannelSuggestion && (1 > filteredsChannelSuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li>
                      <span class="name">No Results</span>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </li>
        <ng-container *ngFor="let item of selectedSecondaryChannels; let i = index; trackBy: trackByName">
          <li class=" abc tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable">
            <ng-container >
              <span class="tagit-label" (click)="editTag(i)">{{item.key}}</span>
            </ng-container>
            <a class="tagit-close">
              <span *ngIf="true" class="text-icon" [ngClass]="{'disabled':locked}" (click)="deleteSChannel(i)">×</span>
              <span class="ui-icon ui-icon-close"></span>
            </a>
            <input type="hidden" value="fsbbfb" name="tags" class="tagit-hidden-field">
          </li>
        </ng-container-->
        <li>
          <label>Unlisted</label>
          <div class="dataField"  id="categoryField" tabindex="0" >
            <input [disabled]="true" id="unlisted" type="checkbox" [checked]="id == null || videoMetadata.unlisted" (change)="setUnlisted($event)">
          </div>
        </li>

        <li *ngIf="enableSaranyu">
          <label>Upload</label>
          <div class="dataField"  id="categoryField" tabindex="0" >
            <span>Youtube</span>
            <input id="unlisted" type="checkbox" [checked]="uploadOnYouTube===true" (change)="setYoutube($event)">
            <span>Saranyu</span>
            <input id="unlisted" type="checkbox" [checked]="uploadOnSaranyu===true" (change)="setSaranyu($event)">
          </div>
        </li>

        <li>
          <label>Playlist
            <img *ngIf="playListError"  class="mandate exclamation-mark" title="{{playListError}}" src="../../../assets/images/exclamationmark.jpeg"/>
          </label>
          <div class="dataField" id="sChannelField" tabindex="0" >
            <input [disabled]="locked" id="sChannelDropdownTextbox" [disabled]="editMode" type="text" class="textBox" #pChannelInput [readonly]="false" placeholder="Add Video To Playlists here."
              [(ngModel)]="playListQuery" (keyup)="filterAutoCompleteUp($event ,'playlist')"
              (keydown)="filterAutoCompleteDown($event ,'playlist')" (focus)="focusInSuggest('playlist')" (focusout)="false" (blur)="closeDropdown($event)">
            <ng-container>
              <div #playList tabindex="0" class="autosuggestion block"
                *ngIf="filteredsPlaylistSuggestion && filteredsPlaylistSuggestion.length > 0 && inside == 'playlist'">
                <ul *ngFor="let item of filteredsPlaylistSuggestion;let i = index">
                  <li tabindex="0" id="playListDropdown{{i}}" (click)="selectAutoComplete('playlist', item)" [class.active]="i === currentSelection">
                    <span class="name">{{item.key}}</span>
                  </li>
                </ul>
              </div>
              <ng-container *ngIf="inside == 'playlist' && filteredsPlaylistSuggestion && (1 > filteredsPlaylistSuggestion.length)">
                <div class="autosuggestion block">
                  <ul>
                    <li>
                      <span class="name">No Results</span>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </ng-container> 
            <ng-container *ngFor="let item of selectedPlaylistChannels; let i = index; trackBy: trackByName">
              <li class="playlist-tagit-choice">
                <ng-container >
                  <span class="playlist-tagit-lable" (click)="editTag(i)">{{item.key}}</span>
                </ng-container>
                <a class="tagit-close">
                  <span *ngIf="true" class="playlist-tagit-close" [ngClass]="{'disabled':status}" (click)="deletePlayList(i)">×</span>
                  <span class="ui-icon ui-icon-close"></span>
                </a>
                <input type="hidden" value="fsbbfb" name="tags" class="tagit-hidden-field">
              </li>
            </ng-container>
          </div>
        </li>
        

        <li *ngIf="videoCms != null">
          <label>Youtube Status</label>
          <div class="dataField"  id="status" tabindex="0" >
            <ng-container *ngIf="videoCms.ytPrimaryUpdateStatus != null && videoCms.ytPrimaryUpdateStatus != 'NOTEXIST'">
              <ng-container *ngIf="videoCms.ytPrimaryUpdateStatus == 'FAILED'">
                <span>UPDATE {{videoCms.ytPrimaryUpdateStatus}}</span>
              </ng-container>
              <ng-container *ngIf="videoCms.ytPrimaryUpdateStatus != 'FAILED'">
                <span>{{videoCms.ytPrimaryUpdateStatus}}</span>
              </ng-container>
             
            </ng-container>
            <ng-container *ngIf="videoCms.ytPrimaryUpdateStatus == null || videoCms.ytPrimaryUpdateStatus == 'NOTEXIST'">
              <ng-container *ngIf="videoCms.ytPrimaryUploadStatus == 'FAILED'">
                <span>UPLOAD {{videoCms.ytPrimaryUploadStatus}}</span>
              </ng-container>
              <ng-container *ngIf="videoCms.ytPrimaryUploadStatus == 'NOTEXIST'">
                <span>NOT UPLOADED YET</span>
              </ng-container>
              <ng-container *ngIf="videoCms.ytPrimaryUploadStatus != 'NOTEXIST' && videoCms.ytPrimaryUploadStatus != 'FAILED'">
                <span>{{videoCms.ytPrimaryUploadStatus}}</span>
              </ng-container>
             
            </ng-container>
          </div>
        </li>
        </ul>
          </div>
          </div>
          </div>
          </div>
          

</div>
</ng-container>
<ng-template #loading>
  <div class="loaderimage block">
    <div class="imagepreloader">
      <div class="a" style="--n: 5;">
        <div class="dot dot1" style="--i: 0;"></div>
        <div class="dot dot2" style="--i: 1;"></div>
        <div class="dot dot3" style="--i: 2;"></div>
        <div class="dot dot4" style="--i: 3;"></div>
      </div>
    </div>
  </div>
</ng-template>

<div class="loaderimage block" *ngIf="showLoader">
  <div class="imagepreloader">
    <!-- <h3>TRANSLATING...</h3> -->
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</div>
